export enum TemplatesEnum {
  Public = "PUBLIC",
  MyTemplates = "MY_TEMPLATES",
  StarredTemplates = "STARRED_TEMPLATES",
  ArchivedTemplates = "ARCHIVED_TEMPLATES",
}
